import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import BarChartReport from "./reports/barChartReport";
import { SquareDashboardApi } from "../../services/SquareOfSolidarity/services";
import MyTicketSkeleton from "./skeleton/MyTicketSkeleton";


const Report = (props) => {
    const [activeTab, setActiveTab] = useState('1');
    const [result, setResult] = useState([])
    const [titles, setTitles] = useState({t1:'', t2:''})
    const tabsIds = [
        { id: '2', name: "عوامل استانی" },
        { id: '1', name: "عوامل فردی" },        
    ]
    const Result = useCallback(async () => {
        const result = await SquareDashboardApi(props.id)
        const line = result.data.find(r => r.type === 2);
        const bar = result.data.find(r => r.type === 3);
        
        setResult({ line: line?.values[0].values, bar: bar?.values[0].values })
        setTitles({ t1: line?.title, t2: bar?.title })
        
    })

    useEffect(() => {
        Result()
    }, [])


    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }


    return (
        <Col xs={12}>
            <Nav tabs>
                {result && tabsIds && tabsIds.map(tab => (
                    <NavItem className={`reportTab`}>
                        <NavLink
                            key={tab.id}
                            className={classnames({ active: activeTab === tab.id })}
                            onClick={() => {
                                toggle(tab.id)
                            }}>
                            {tab.name}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <Row className={'p-3'}>
                        <Col sm="12">
                            <div className="chart-area" style={{ minHeight: 300 }}>
                                {result.length !== 0 &&
                                    <BarChartReport
                                        data={result.line}
                                        label={'description'}
                                        title={titles.t1}
                                    />
                                }
                            </div>
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="2">
                    <Row className={'p-3'}>
                        {result.length !== 0 &&
                            <BarChartReport
                                data={result.bar}
                                type={'h'}
                                label={'description'}
                                title={titles.t2}
                            />
                        }
                    </Row>
                </TabPane>
            </TabContent>
        </Col>
    );
}

export default Report;